import FieldsFactory from "../../fields-factory";
import FieldProto from "../../proto/field-proto";
import {EntityType} from "../../../gd/const/item";
import FieldConfig from "../../proto/field-config";
import {GroupedData} from "../../../data-structures/group";

export default class FieldsCollection {

    protected _fields       : FieldProto[]
    protected entityType    : EntityType

    constructor(fieldsConfig:FieldConfig[], entityType:EntityType=EntityType.DYNAMIC_MODEL) {

        this._fields    = [];
        this.entityType = entityType

        _.map(fieldsConfig, fieldConfig=>{
            fieldConfig.entityType = this.entityType // new patch by Vic
            this.addField(FieldsFactory.get(fieldConfig));
        })
    }

    all(): FieldProto[] {
        return this._fields;
    }

    get models() {return this._fields}

    hasField(fieldId:fieldId):boolean {
        const field = _.find(this._fields, field=>field.fieldId === fieldId)
        return !!field
    }

    get = (fieldId:fieldId):FieldProto => {
        // return _.find(this._fields, field=>field.fieldId === fieldId)
        const result = _.find(this._fields, field=>field.fieldId === fieldId)

        if (!result) {
            console.warn("FieldCollection (v3) ERROR #FC-1 Field not found. fieldId=", fieldId)
            // throw Error("no field with id=" + fieldId + "found")
            return new FieldProto({})
        }

        return result
    }

    fieldExists(fieldId:fieldId):boolean {
        return !!_.find(this._fields, field=>field.fieldId === fieldId)
    }

    get isEmpty() {
        return this.models.length < 1
    }

    addField(field:FieldProto|false) {
        if (!field) return;

        // automatically set entity type for all fields in this collections unless one exists !
        if (!field.entityType) {
            field.entityType = this.entityType
        }

        this._fields.push(field);
    }

    public addFieldFromConfig(fieldConfig: FieldConfig) {
        const field = FieldsFactory.get(fieldConfig)
        this.addField(field)
    }

    removeById(fieldId:string) {
        _.remove(this._fields, field=>field.fieldId === fieldId);
    }

    customFields() {
        return _.filter(this._fields, field=>field.isCustom)
    }

    // return array of cf ids used when add field to prevent double ids
    getCustomFieldIds() {
        return _.map(this.customFields(), field=>field.fieldId);
    }

    reset(fields: FieldProto[]) {
        this._fields = [];

        _.map(fields, field=>{
            this.addField(field)
        })
    }

    // return all fields available for conditions
    get structureConditions():GroupedData {
        return []
    }

    // return all fields available for sorting
    get structureSorting():GroupedData {
        return []
    }

    // Export to json object we store somewhere
    // e.g. CRM contact -> save to company settings
    toJson() {
        return _.map(this._fields, field=>field.toJson())
    }

    // used to build glist manage fields list
    toGlist() {
        return _.map(this._fields, field=> {
            return {
                id: field.fieldId,
                name: field.label,
                type: field.type,
                field: field
            }
        })
    }

}
